import { z } from 'zod';

const contactString = z
  .string()
  .nullish()
  .transform((value) => value ?? '');

export type ContactDTO = z.infer<typeof contactSchema>;
export const contactSchema = z.object({
  guid: contactString,
  name: contactString,
  address: contactString,
  city: contactString,
  state: contactString,
  zip: contactString,
  contact: contactString,
  phone: contactString,
  email: contactString,
  notes: contactString,
});

const optionalString = z.string().prefault('');
const emailSchema = z.email();

const optionalEmailList = z
  .string()
  .refine(
    (value) =>
      !value ||
      value
        .trim()
        .split(',')
        .every((email) => emailSchema.safeParse(email.trim()).success),
    'Enter valid email(s)',
  )
  .optional()
  .prefault('');

export type ContactEditDTO = z.input<typeof contactEditSchema>;
export const contactEditSchema = z.object({
  name: z.string().min(1, 'This field is required').prefault(''),
  address: optionalString,
  city: optionalString,
  state: optionalString,
  zip: optionalString,
  contact: optionalString,
  phone: optionalString,
  email: optionalEmailList,
  notes: optionalString,
});
